import { BlocksForm, RenderBlocks } from '@plone/volto/components';
import { ButtonProps } from '@designsystem/stories/02-atoms/Button';
import { MediaProps } from '@designsystem/stories/02-atoms/Media';
import { ButtonGroup } from '@designsystem/stories/03-molecules/ButtonGroup';
import { Leri } from '@designsystem/stories/04-organisms/Leri';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

export interface LeriItem {
  title?: string;
  media?: MediaProps;
  actions?: ButtonProps[];
  blocks?: Record<string, any>;
  blocks_layout?: { items: any };
}

export interface BlockDataProps {
  items?: LeriItem[];
  placeholder?: string;
}

export interface ViewProps {
  data: BlockDataProps;
  isEdit?: boolean;
  block: string;
  pathname: string;
  onChangeBlock?: (blockId: string, newData: any) => void;
  blocksConfig: any;
  manage?: any;
  onChangeField?: (id: string, value: any) => void;
  selected?: boolean;
  selectedItem?: number;
  selectedBlock: string | null;
  onSelectBlock: (
    blockId: string,
    isMultipleSelection: boolean,
    e:
      | React.MouseEvent<HTMLElement>
      | React.KeyboardEvent<HTMLElement>
      | undefined,
    selectedBlock: string | null,
  ) => void;
  metadata?: any;
  properties?: any;
  multiSelected?: string[];
}

const View = (props: ViewProps) => {
  const {
    block,
    data,
    onChangeBlock,
    onChangeField,
    pathname,
    selected,
    selectedItem,
    selectedBlock,
    onSelectBlock,
    manage,
    blocksConfig,
    isEdit,
    multiSelected,
  } = props;

  const metadata = props.metadata || props.properties;
  const items = data?.items || [];

  return (
    <>
      {items.map((item, i) => (
        <Leri
          key={i}
          even={i % 2 === 1}
          {...(normalizeContent(item, false, {
            '40rem': '100vw',
            '106rem': '50vw',
            max: '53rem',
          }) as Record<string, any>)}
        >
          {item?.title && <h3 className="leri__title">{item.title}</h3>}
          {!isEdit && item?.blocks && item?.blocks_layout?.items && (
            <RenderBlocks content={item || {}} />
          )}
          {isEdit && (
            <BlocksForm
              {...props}
              isMainForm={false}
              metadata={metadata}
              properties={item}
              manage={manage}
              selectedBlock={
                selected && selectedItem === i ? selectedBlock : null
              }
              allowedBlocks={blocksConfig.leri.allowedBlocks}
              title={data.placeholder}
              onSelectBlock={(
                id: string,
                l: any,
                e:
                  | React.MouseEvent<HTMLElement>
                  | React.KeyboardEvent<HTMLElement>
                  | undefined,
              ) => {
                const isMultipleSelection = e
                  ? e.shiftKey || e.ctrlKey || e.metaKey
                  : false;
                onSelectBlock(id, isMultipleSelection, e, selectedBlock);
              }}
              onChangeFormData={(newFormData: any) => {
                const newData = { ...data };
                if (newData.items && newData.items[i]) {
                  newData.items[i] = {
                    ...newData.items[i],
                    ...newFormData,
                  };
                }
                onChangeBlock && onChangeBlock(block, newData);
              }}
              onChangeField={(id: string, value: any) => {
                if (['blocks', 'blocks_layout'].indexOf(id) > -1) {
                  const newData = { ...data };
                  if (newData.items && newData.items[i]) {
                    newData.items[i] = {
                      ...newData.items[i],
                      ...value,
                    };
                  }
                  onChangeBlock && onChangeBlock(block, newData);
                } else {
                  onChangeField && onChangeField(id, value);
                }
              }}
              pathname={`${pathname}/${i}`}
              multiSelected={multiSelected}
            />
          )}
          {item?.actions && (
            <ButtonGroup
              className="leri__actions"
              items={normalizeContent(item.actions) as ButtonProps[]}
            />
          )}
        </Leri>
      ))}
    </>
  );
};

export default View;
